import * as types from '../actions/ActionTypes';
import InitialState from './InitialState';
import { assign } from '../../../shared/Assign';

export default function photographerOverviewReducer(
    state: any = InitialState,
    action: { type: string; result: any }
) {
    let newState = assign({}, state);

    switch (action.type) {
        case types.GET_PHOTOGRAPHER_OVERVIEW_SUCCESS:
            newState = action.result;
            return newState;
        default:
            return state;
    }
}
